import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { NationalModifiersDetails, NationalModifiersSelection } from '../types/nationalModifiers.types';
import { useSTKContext } from '../context/context';

export const useNationalModifiers = (enabled: boolean, type?: string) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<NationalModifiersDetails[]>>({
    queryKey: ['nationalModifiers', type],
    queryFn: () => apiClient.get<NationalModifiersDetails[]>(`/nationalmodifiers${type ? `?type=${type}` : ''}`),
    enabled,
  });
};

export const useUpdateNationalModifiersLock = () => {
  const { apiClient } = useSTKContext();
  return useMutation({
    mutationFn: (requestBody: NationalModifiersSelection[]) => apiClient.put('/nationalmodifiers/update', requestBody),
  });
};

export const identicalArrays = (originalData: NationalModifiersDetails[], currentData: NationalModifiersDetails[]) => {
  let identicalData = true;
  const toBool = (value: unknown) => (value === 'false' ? false : Boolean(value));
  if (currentData === originalData) {
    identicalData = true;
  }
  if (currentData.length !== originalData.length) {
    return false;
  }
  for (let i = 0; i < currentData.length; i += 1) {
    const newIsLock = toBool(currentData[i].isLock);
    const newIsVisible = toBool(currentData[i].isVisible);
    const newIsMandatory = toBool(currentData[i].isMandatory);
    const newIsZeroPriced = toBool(currentData[i].isZeroPriced);

    const originalIsLock = toBool(originalData[i].isLock);
    const originalIsVisible = toBool(originalData[i].isVisible);
    const originalIsMandatory = toBool(originalData[i].isMandatory);
    const originalIsZeroPriced = toBool(originalData[i].isZeroPriced);
    if (
      newIsLock !== originalIsLock ||
      newIsVisible !== originalIsVisible ||
      newIsMandatory !== originalIsMandatory ||
      newIsZeroPriced !== originalIsZeroPriced
    ) {
      return false;
    }
  }
  return identicalData;
};
